import { sortByDue } from "../tasks/query.js";
import type { Task } from "../tasks/types.js";
import { addMinutes, fromIso, isAfter, isBefore } from "../time.js";

/** Open tasks with due_at in the next `windowMinutes`, sorted ascending. */
export function upcomingWithin(tasks: Task[], now: Date, windowMinutes: number): Task[] {
  const cutoff = addMinutes(now, windowMinutes);
  return sortByDue(
    tasks.filter((t) => {
      if (t.status !== "open" || !t.due_at) return false;
      const due = fromIso(t.due_at);
      return !isBefore(due, now) && !isAfter(due, cutoff);
    }),
  );
}
